import {
  Home, TrendingUp, Landmark, Scale, PiggyBank, Receipt, GraduationCap,
  Lock, Target, Calculator, LineChart, CreditCard, Shield, Percent, Key, TrendingDown,
} from "lucide-react";

const MAP = {
  Home, TrendingUp, Landmark, Scale, PiggyBank, Receipt, GraduationCap,
  Lock, Target, Calculator, LineChart, CreditCard, Shield, Percent, Key, TrendingDown,
};

export function Icon({ name, ...props }) {
  const Cmp = MAP[name] || Calculator;
  return <Cmp {...props} />;
}
